import { render, staticRenderFns } from "./CoreLink.vue?vue&type=template&id=071af108&scoped=true&"
import script from "./CoreLink.vue?vue&type=script&lang=js&"
export * from "./CoreLink.vue?vue&type=script&lang=js&"
import style0 from "./CoreLink.vue?vue&type=style&index=0&id=071af108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071af108",
  null
  
)

export default component.exports